(() => {
  if (!customElements.get('biz-compare-demo')) {
    class CompareDemo extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true; this.visible = false; this.paused = false;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.cards = [...this.querySelectorAll('[data-demo-card]')];
        this.items = this.cards.map(card => {
          try { return JSON.parse(card.querySelector('[data-demo-product]').textContent).find(Boolean); } catch { return null; }
        });
        this.button = this.querySelector('[data-demo-toggle]');
        this.update = () => { this.renderOffers(); this.syncMotion(); };
        this.toggle = () => { this.paused = !this.paused; this.button.setAttribute('aria-pressed', String(this.paused)); this.button.textContent = this.paused ? '▶ Play' : 'Ⅱ Pause'; this.syncMotion(); };
        this.button.addEventListener('click', this.toggle);
        this.reduced.addEventListener('change', this.update);
        document.addEventListener('visibilitychange', this.update);
        this.observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.syncMotion(); }, {threshold:0.2}) : null;
        if (this.observer) this.observer.observe(this); else this.visible = true;
        this.update();
      }
      syncMotion() {
        const allowed = !this.reduced.matches;
        this.button.hidden = !allowed;
        this.classList.toggle('is-animated', allowed);
        this.classList.toggle('is-running', allowed && this.visible && !document.hidden && !this.paused);
      }
      renderOffers() {
        clearTimeout(this.expiryTimer);
        const now = Date.now(), times = []; let nextExpiry = Infinity;
        this.cards.forEach((card, index) => {
          const item = window.BizSpotlightEngine?.eligible(this.items[index], {allowPrime:true}, now);
          const image = card.querySelector('[data-demo-image]'), price = card.querySelector('[data-demo-price]'), badge = card.querySelector('[data-demo-discount]');
          image.hidden = !item; card.querySelector('[data-demo-placeholder]').hidden = !!item;
          badge.hidden = !item || !item.displayDiscount;
          card.querySelector('[data-demo-edeal]').hidden = !item || item.displayDiscount < 20;
          card.querySelector('[data-demo-limited]').hidden = !item || !item.limited;
          card.querySelector('[data-demo-prime]').hidden = !item || !item.prime;
          price.dataset.sale = String(!!item && item.displayDiscount > 0);
          if (!item) { image.removeAttribute('src'); price.textContent = 'Check current offer'; badge.textContent = ''; return; }
          if (image.getAttribute('src') !== item.image) image.src = item.image;
          price.textContent = new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(item.price / 100);
          badge.textContent = item.displayDiscount + '% off';
          times.push(new Date(item.snapshot.fetchedAt).toLocaleString(undefined,{dateStyle:'medium',timeStyle:'short'}));
          nextExpiry = Math.min(nextExpiry, item.until);
        });
        this.querySelector('[data-demo-updated]').textContent = times.length ? 'Offer data updated: ' + [...new Set(times)].join(' · ') + '.' : 'Open a product to check its current offer.';
        if (Number.isFinite(nextExpiry)) this.expiryTimer = setTimeout(() => this.renderOffers(), Math.max(100, nextExpiry - now + 20));
      }
      disconnectedCallback() {
        this.observer?.disconnect(); clearTimeout(this.expiryTimer);
        this.button?.removeEventListener('click', this.toggle);
        this.reduced?.removeEventListener('change', this.update);
        document.removeEventListener('visibilitychange', this.update); this.ready = false;
      }
    }
    customElements.define('biz-compare-demo', CompareDemo);
  }
  // Reveal once, only while visible. Nothing is hidden before JavaScript runs.
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches || !('IntersectionObserver' in window)) return;
  const seen = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      const card = entry.target;
      if (!entry.isIntersecting || card.hidden) continue;
      card.classList.add('bz-card-enter');
      observer.unobserve(card);
      card.addEventListener('animationend', () => card.classList.remove('bz-card-enter'), {once:true});
    }
  }, {threshold:0.15});
  const watch = root => root.querySelectorAll('[data-promo-card]').forEach(card => {
    if (!seen.has(card) && !card.hidden) { seen.add(card); observer.observe(card); }
  });
  watch(document);
  document.addEventListener('bz:promo-ready', event => watch(event.target.parentElement));
  document.addEventListener('shopify:section:load', event => watch(event.target));
  reduced.addEventListener('change', event => { if(event.matches) observer.disconnect(); });
})();
